export enum TimeSinceUpdated {
  MONTHS_6 = '6',
  MONTHS_12 = '12',
  MONTHS_24 = '24',
}

/** Retired "All time" value, still present in saved links and bookmarks */
export const LEGACY_TIME_SINCE_UPDATED_ALL_TIME = '-1'

export const parseTimeSinceUpdated = (value?: string): TimeSinceUpdated | undefined => {
  if (value === LEGACY_TIME_SINCE_UPDATED_ALL_TIME) {
    return TimeSinceUpdated.MONTHS_24
  }

  return Object.values(TimeSinceUpdated).find((option) => option === value)
}
